<template>
  <div id="v2-course-pay" class="slideUp transaction">
    <Browser v-if="$route.query.method === 'alipay' && $store.state.isWechat" />
    <Agreement v-if="agree.show" @state="agree.checked = $event || agree.checked; agree.show = false" />
    <CouponSelector
      v-if="isShowCouponSelector"
      :coupons="data.meta.user_coupon"
      :coupon="selectedCoupon"
      @selectCoupon="selectedCoupon = $event"
      @close="isShowCouponSelector = false"
    />
    <div v-if="status === 0">
      <div id="close" @click="$closeModal()">
        <i class="anyteachicon anyteach-prev" />
        返回
      </div>
      <HeaderView :title="title" :price="actualPrice" />
      <div class="card">
        <h2>场次 / 价格</h2>
        <h3>{{ subtitle }}</h3>
        <p v-if="data.event.subtitle_detail" class="detail">
          <i class="anyteachicon anyteach-warning" />
          {{ data.event.subtitle_detail }}</p>
        <div v-if="data.meta.is_first && data.event.is_first">
          <h2>首单优惠</h2>
          <h3 class="red">-¥{{ data.event.is_first }}</h3>
        </div>
        <div
          v-else-if="
            data.meta.user_coupon &&
              data.meta.user_coupon.length &&
              data.event.price > 0 &&
              data.event.is_coupon
          "
        >
          <h2>优惠</h2>
          <h3 @click="isShowCouponSelector = true">
            <span v-if="!selectedCoupon" class="blue">
              {{ data.meta.user_coupon.length }} 张学习券可用
              <i class="anyteachicon anyteach-jiantouyou more" />
            </span>
            <span v-else class="red">-¥{{ selectedCoupon.amount }}</span>
          </h3>
        </div>
        <h2>原价</h2>
        <h3>¥{{ data.event.price }}</h3>
        <h2>实际支付</h2>
        <h3>¥{{ actualPrice }}</h3>
        <h2>学生</h2>
        <Student v-model="student_id" mode="select" ref="student" />
        <Method v-if="actualPrice" v-model="method" />
        <Agree v-model="agree.checked" :size="agree.size">
        <p class="agree">
          <span class="text" @click="agree.checked = !agree.checked">我已阅读并同意</span>
          <span class="link" @click="agree.show = true">《AnyTeach 服务条款》</span>
        </p>
      </Agree>
      </div>
      <div :disabled="isLoading" class="button button-pop" @click="checkStudent">
        <span v-if="!actualPrice">免费下单</span>
        <span v-else>立即支付</span>
      </div>
    </div>
    <div v-if="status === 1" class="empty">
      <div class="wrapper">
        <i class="anyteachicon anyteach-thumbs-up red animated bounce" />
        <h1 class="pay_tip">支付成功</h1>
        <p>
          <span>请添加小管家，以帮助您开始上课</span>
          <CustomerService :component="true" />
        </p>
        <router-link to="/courses" tag="div" class="back button-pop">
          <i class="anyteachicon anyteach-back" />
          <span>返回上一页</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderView from "./Header"
import Browser from "./Browser"
import Method from "./Method"
import CouponSelector from "./CouponSelector"
import Student from "@/components/student/Main"
import CustomerService from "../../../public/CustomerService"
import Dialog from "@/components/dialog"
import Agreement from "@/components/homelesson/post/Agreement"
import Agree from "mand-mobile/lib-vw/agree"

export default {
  name: "V2CoursePay",
  components: { HeaderView, Browser, CouponSelector, Student, CustomerService, Method,    Agree,
    Agreement, },
  props: ["data", "title", "subtitle", "is_livecode", "courseType"],
  data() {
    return {
      state: {
        student: false,
        laoding: false,
      },
      agree: {
        checked: true,
        size: "md",
        show: false,
      },
      status: 0,
      method: "wechat",
      isShowCouponSelector: false,
      selectedCoupon: "",
      actualPrice:
        this.data.meta.is_first && this.data.event.is_first
          ? this.data.event.price - this.data.event.is_first
          : this.data.event.price,
      isLoading: false,
      redirectTimer: 3,
      student_id: null,
      notice: ""
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    student() {
      return this.$store.state.user.student
    },
  },
  watch: {
    "$route": {
      immediate: true,
      handler(val) {
        const { query } = val
        if (query.method) {
          this.method = query.method
        }
        if (query.coupon_id) {
          this.selectedCoupon = this.data.meta.user_coupon.find(item => item.id === Number(query.coupon_id)) || ""
        }
        if (query.student_id) {
          const student_id = Number(query.student_id)
          if (this.user.student.find(item => item.id === student_id)) this.student_id = student_id
        }
      }
    },
    method: {
      immediate: true,
      handler(val) {
        if (val === "wechat_h5") {
          this.method = "wechat"
        }
      }
    },
    selectedCoupon() {
      if (!this.selectedCoupon) {
        return (this.actualPrice = this.data.event.price)
      }
      this.actualPrice =
        this.selectedCoupon.amount > this.data.event.price
          ? 0
          : this.data.event.price - this.selectedCoupon.amount
    },
    status() {
      if (0 && this.status && this.is_livecode) {
        const timeout = this.redirectTimer * 1000
        setTimeout(() => {
          window.clearInterval(countdown)
          this.redirectTimer = timeout / 1000 - 1
          this.$router.push("/live/how-to")
        }, timeout)
        const countdown = window.setInterval(() => {
          this.redirectTimer--
        }, 1000)
      }
    },
  },
  created() {
    this.$store.dispatch("user")
    if (this.data.event.is_prereq === 2) {
      this.getNotice()
    }
  },
  mounted() {
    this.$toastHide()
    if (this.student.length && this.student.length === 1) {
      this.student_id = this.student[0].id
    }
  },
  methods: {
    async getNotice() {
      const { value_1 } = await this.$api.api.CUSTOM(`pay_notice_${this.courseType}`)
      this.notice = value_1
    },
    async confirmPay() {
      if (this.data.event.is_prereq === 0) {
        return this.payMethod()
      }
      if (this.data.event.is_prereq === 1) {
        Dialog.confirm({
          title: "购课提醒",
          content: "您是否已和小管家沟通，获得购课资格？",
          confirmText: "是",
          cancelText: "否",
          onConfirm: () => {
            this.payMethod()
          },
        })
      }
      if (this.data.event.is_prereq === 2) {
        if (this.notice.length) {
          Dialog.confirm({
            title: "购课须知",
            content: this.notice,
            html: true,
            confirmText: "同意并下单",
            onConfirm: () => {
              this.payMethod()
            },
          })
        } else {
          this.payMethod()
        }
      }
    },
    checkStudent() {
      if (!this.student_id) {
        this.$toast("请选择学生")
        this.$refs.student.components.list = true
      } else if (!this.agree.checked) {
        this.$toast("请同意条款")
      } else {
        this.confirmPay()
      }
    },
    payMethod() {
      if (this.method === "wechat") {
        if (this.$store.state.isWechat) {
          this.wechat()
        } else {
          this.wechat_h5()
        }
      }
      if (this.method === "alipay") {
        if (this.$store.state.isWechat) {
          let url = `?phone=${this.$store.state.user.mobile}&pay=1&cd_id=${this.data.event.id}&method=alipay`
          url += this.selectedCoupon.id ? `&coupon_id=${this.selectedCoupon.id}` : ""
          url += this.student_id ? `&student_id=${this.student_id}` : ""
          this.$router.push(url)
        } else {
          this.alipay()
        }
      }
    },
    goViewOrder({ out_trade_no }) {
      this.$toastHide()
      this.$router.push("/order/view?out_trade_no=" + out_trade_no)
    },
    getPayConfig(pay_method) {
      this.isLoading = true
      const apps = {
        wechat_h5: "微信",
        alipay: "支付宝"
      }
      if (apps[pay_method] && this.actualPrice) {
        this.$toastLoading(`正在前往${apps[pay_method]}...`)
      } else {
        this.$toastLoading()
      }
      return {
        id: this.data.event.id,
        coupon: this.selectedCoupon.id || "",
        pay_method,
        student_id: this.student_id
      }
    },
    async wechat_h5() {
      const config = this.getPayConfig("wechat_h5")
      const { code, msg } = await this.$api.order.CREATE_ORDER(config)
      this.isLoading = false
      if (code === "2000") {
        return this.goViewOrder(msg)
      }
      if (code === "1005") {
        return window.location.href = msg.redirect_url
      }
      this.$toastError(`${msg}（${code}）`)
    },
    async alipay() {
      const config = this.getPayConfig("alipay")
      const { code, msg } = await this.$api.order.CREATE_ORDER(config)
      this.isLoading = false
      if (code === "2000") {
        return this.goViewOrder(msg)
      }
      if (code === "1000") {
        return document.write(msg)
      }
      this.$toastError(`${msg}（${code}）`)
    },
    async wechat() {
      const config = this.getPayConfig("wechat")
      const { code, msg } = await this.$api.order.CREATE_ORDER(config)
      this.isLoading = false
      this.$toastHide()
      if (code === "2000") {
        return this.goViewOrder(msg)
      }
      if (code === "1005") {
        let { config } = msg
        config.success = () => {
          this.goViewOrder(msg)
        }
        return wx.chooseWXPay(config)
      }
      this.$toastError(`${msg}（${code}）`)
    },
  },
}
</script>
<style scoped lang="scss">
@import "../../../../../static/css/transaction.scss";

#v2-course-pay {
  .button {
    padding: 13px 0;
    position: relative;
    margin: 20px 5%;
    border: 0;
    i {
      margin: 0 5px 0 0;
    }
    .weui-loading {
      bottom: 10px;
      margin: 0;
      position: absolute;
    }
  }
  .friend {
    border-color: white;
    margin: 0 auto;
  }

  .wrapper {
    padding: 5vh 0 5vh 0;
    .close {
      position: absolute;
      top: 100px;
      left: 5%;
      font-size: 0.9rem;
    }
    h1 {
      font-size: 25px;
      font-weight: bold;
    }
    i {
      font-size: 50px;
      margin-bottom: 10px;
    }
    .back {
      font-size: 0.9rem;
      margin: 50px auto;
      @include avenir-demi();
      color: $red;
      i {
        font-size: inherit;
      }
      padding: 5px 15px;
      display: inline-block;
    }
  }
  .await {
    padding-top: 10px;
    h3 {
      display: flex;
      align-items: center;
    }
  }

  .card {
    @include card();
    width: 70%;
    .more {
      float: right;
    }
    .blue,
    .red {
      transition: all 0.1s;
      font-weight: 500;
      &:active {
        opacity: 0.7;
      }
    }
    .detail {
      color: black;
      font-size: 12px;
      opacity: 0.4;
    }
  }
  .pay_tip {
    margin-top: 20px;
  }
  ::v-deep .md-agree {
    margin: 15px 0 -5px 0;
    .md-agree-icon {
      // margin: 0 3px 0 0;
      margin: 0;
      width: auto;
      height: auto;
    }
  }
  .agree {
    font-size: 0;
    span {
      font-size: 0.8rem;
      opacity: 0.6;
    }
    .text {
      opacity: 0.6;
    }
    .link {
      @include avenir();
      font-weight: 500;
      border-bottom: 1px solid #dadada;
    }
  }
}
</style>
